import { seoKeywords } from '../home/Home.seo';

export const teamSeo = {
  title: 'Rumble Fish | Our Team',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        "Learn more about our team of IT experts, and see why we're the best match for your software development project. We support our software engineers in their professional growth. Are you looking for a great development team? Check us out!",
    },
  ],
};
